<template>
    <el-dialog v-model="visible" title="입고내역 선택" width="80%">      
        <el-row :gutter="10" class="mb-3">
          <el-col :span="12">
            <el-input
              v-model="searchQuery"
              placeholder="검색어를 입력하세요 (품명, 색상, 규격)"
              @input="fetchReceivings"
            />
          </el-col>
        </el-row>
  
        <el-table
          :data="receivings || []"
          style="width: 100%"
          :loading="loading"
          highlight-current-row
          @row-dblclick="selectReceiving"
          @selection-change="handleSelectionChange"
          :row-key="row => row.id"
          :selectable="isRowSelectable"

        >
          <el-table-column type="selection" width="55" />
          <!-- 2026-07-15 발주↔지결 연결: 응답에 실재하는 필드로 정정
               (기존 material_order_item_detail.* 는 응답에 없어 빈 컬럼이었음) -->
          <el-table-column prop="style_number" label="스타일번호" width="110" />
          <el-table-column prop="item_name" label="품명" min-width="140" />
          <el-table-column prop="item_color" label="색상" width="90" />
          <el-table-column prop="item_specification" label="규격" width="100" />
          <el-table-column prop="received_date" label="입고일" width="100" />
          <el-table-column prop="quantity" label="입고 수량" width="90" align="right" />
          <el-table-column prop="unit_price" label="발주 단가" width="90" align="right" />
          <el-table-column label="금액" width="110" align="right">
            <template #default="{ row }">
              {{ Number(row.amount || 0).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="is_fully_expensed"  label="지출완료여부"
              :formatter="row => row.is_fully_expensed ? '완료' : '미완료'"
        />
        </el-table>

        <!-- 이 위치로 이동 -->
        <template #footer>
            <el-button @click="visible = false">취소</el-button>
            <el-button type="primary" @click="confirmSelection">추가</el-button>

        </template>          
    </el-dialog>
</template>
  
  <script setup>
  import { ref, watch } from 'vue'
  import axiosInstance from '@/api/axios'
  
  const props = defineProps({
    modelValue: Boolean,
    partnerCompanyId: { type: [String, Number], default: null } // 거래처 ID를 전달받음
  })
  
  const emits = defineEmits(['update:modelValue', 'select'])  
  const visible = ref(false)

  const receivings = ref([])
  const searchQuery = ref('')
  const loading = ref(false)
  
  watch(() => props.modelValue, (val) => {
    visible.value = val
    if (val) fetchReceivings()
  })
  
  watch(visible, (val) => {
    emits('update:modelValue', val)
  })
  
  async function fetchReceivings() {
    loading.value = true
    try {
      const response = await axiosInstance.get('/receivings/', {
        params: {
          search: searchQuery.value,
          available: true,
          supplier_id: props.partnerCompanyId , // ✅ 거래처 필터
          is_fully_expensed: false  // ✅ 추가
        }
      })
      receivings.value = response.data.results
      console.log(receivings.value)
    } catch (error) {
      console.error('입고내역 불러오기 오류:', error)
    } finally {
      loading.value = false
    }
  }
  
  function isRowSelectable(row) {
    return !row.is_fully_expensed; // ✅ 지출완료가 아니어야 선택 가능
  }

  function selectReceiving(row) {
    emits('select', row)
    visible.value = false
  }

  const selectedRows = ref([])

function handleSelectionChange(rows) {
  selectedRows.value = rows
}

function confirmSelection() {
  emits('select', selectedRows.value)  // 부모로 emit
  console.log(selectedRows.value)
  visible.value = false
}


  </script>
  
  <style scoped>
  .mb-3 {
    margin-bottom: 1rem;
  }
  </style>
  